import React from 'react';
import store from '../../../../Store';
import {setSiteIDLogs} from "./Logs-Action";
import {withRouter} from "react-router";
import {connect} from "react-redux";
import getLogs from "../../../../ajax/actions/logs/Logs_get";

class LogsWorker extends React.Component {

    constructor(props) {
        super(props);
        store.dispatch(setSiteIDLogs(props.match.params.id))
        store.dispatch(getLogs(props.match.params.id))
    }

    render() {
        return null
    }
}

function mapStateToProps(state) {
    let {organizationDashboard, getSiteStatus, getErrorLogs, getAccessLogs} = state;
    let {organization_id} = organizationDashboard.data;
    return {organizationDashboard, organization_id, getSiteStatus, getErrorLogs, getAccessLogs};
}

export default withRouter(connect(mapStateToProps)(LogsWorker));